module.exports = __webpack_public_path__ + "static/media/icon7.3d302218.png";